var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161,
    height: 160,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 158.638,
    height: 158.638,
    x: 1.181,
    y: 0.977,
    fill: "#e8f3fc",
    rx: 79.319
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 158.638,
    height: 158.638,
    x: 1.181,
    y: 0.977,
    stroke: "#0b75c2",
    strokeWidth: 0.75,
    rx: 79.319
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0b75c2",
    strokeLinecap: "round",
    strokeWidth: 5.064,
    d: "M71.036 94.46c2.87 2.128 6.363 3.377 10.127 3.377s7.259-1.25 10.128-3.376"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b75c2",
    d: "M91.291 80.956c1.865 0 3.376-2.267 3.376-5.064s-1.511-5.064-3.376-5.064-3.376 2.267-3.376 5.064 1.512 5.064 3.376 5.064m-20.255 0c1.864 0 3.376-2.267 3.376-5.064s-1.512-5.064-3.376-5.064c-1.865 0-3.376 2.267-3.376 5.064s1.511 5.064 3.376 5.064"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0b75c2",
    strokeLinecap: "round",
    strokeWidth: 5.064,
    d: "M48.08 74.207a33.8 33.8 0 0 1 26.332-26.332M48.079 87.711a33.8 33.8 0 0 0 26.333 26.332m39.835-39.836a33.8 33.8 0 0 0-26.332-26.332m26.332 39.836a33.8 33.8 0 0 1-26.332 26.332"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.28d79b556af096f4be9cf22e32085777.svg";
export { ForwardRef as ReactComponent };